export interface SearchParams {
  search: string;
  sortBy: string;
  descending: boolean;
}

export const initialSearchParams: SearchParams = {
  search: "",
  sortBy: "",
  descending: false,
};
